import { render } from "./PickupPointIcon.vue?vue&type=template&id=760fe9b4"
import script from "./PickupPointIcon.vue?vue&type=script&lang=js"
export * from "./PickupPointIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__